// extracted by mini-css-extract-plugin
export default {"formDiv":"styles_formDiv__6dDwt","gif":"styles_gif__xU+d9"};